class MyDialog extends HTMLElement{
    constructor(){
        super()

        this.attachShadow({mode: 'open'})

        this.shadowRoot.innerHTML = `
        <style>
            :host {
            display: none;
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 9999;
            }
            
            .overlay {
            position: absolute;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.7);
            cursor: pointer;
            }
            
            .content {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: white;
            padding: 2rem;
            min-width: 300px;
            max-width: 90vw;
            max-height: 80vh;
            overflow-y: auto;
            z-index: 10000;
            border-radius: 8px;
            }
            
            .close-btn {
            position: absolute;
            top: 10px;
            right: 10px;
            background: none;
            border: none;
            font-size: 1.5rem;
            cursor: pointer;
            padding: 0;
            width: 30px;
            height: 30px;
            }
        </style>
        
        <div class="overlay" part="overlay"></div>
        <div class="content" part="content">
            <button class="close-btn" part="close-button">×</button>            
            <slot></slot>
        </div>
        `
    }

    // expose attr
    static get observedAttributes(){
        return [width, height]
    }
    attributeChangeCallback(name, oldValue, newValue){
        switch (name) { 
            case width:
                this.shadowRoot.querySelector('.content').style.width = newValue
                break;

            case height:
                this.shadowRoot.querySelector('.content').style.width = newValue
                break;
        
            default:
                break;
        }

    }

    // when dialog registed in dom
    connectedCallback(){
        // click close
        this.shadowRoot.querySelector('.overlay').addEventListener('click', ()=>this.close())
        this.shadowRoot.querySelector('.close-btn').addEventListener('click', ()=>this.close())

        // esc close
        document.addEventListener('keydown',this.handleKeydown.bind(this))
    }

    // when dialog removed from dom
    disconnectCallback(){
        // remove all es bond with document
        document.removeEventListener('keydown', this.handleKeydown.bind(this))
    }

    // methods
    open(){
        this.style.display = 'block'
        document.body.style.overflow = 'hidden'
    }

    close(){
        this.style.display = 'none'
        document.body.style.overflow = 'auto'
    }

    handleKeydown(e){
        if(e.key === 'Escape') this.close()
    }
}

customElements.define('my-dialog', MyDialog)